import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pdfeditor');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pdfeditor',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pdfeditor/view.scss */
:host {
  display: block;
}

img {
  -webkit-user-drag: none;
  user-select: none;
}`],
})
export class PagePdfeditorComponent implements OnInit {
    public filename: string = '';
    public selectedFile: string = '';
    public pdfFiles: any[] = [];
    public pageCount: number = 1;
    public currentPage: number = 1;
    public pageInput: number = 1;
    public zoom: number = 1.35;
    public loading: boolean = true;
    public saving: boolean = false;
    public message: string = '';
    public pageImage: string = '';
    public pageWidth: number = 1;
    public pageHeight: number = 1;
    public imageWidth: number = 1;
    public imageHeight: number = 1;
    public renderScale: number = 1;
    public pageElements: any[] = [];
    public selectedElement: any = null;
    public selectedDraft: any = null;
    public edits: any = {};
    public savedFile: string = '';
    public outputs: any[] = [];
    public elementQuery: string = '';
    public elementType: string = 'all';

    private pointerState: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.selectedFile = new URLSearchParams(location.search).get('file') || '';
        await this.loadInfo();
        await this.loadPage(1);
        await this.service.render();
    }

    public get editList(): any[] {
        return Object.keys(this.edits).map((key) => this.edits[key]);
    }

    public get editCount(): number {
        return this.editList.length;
    }

    public get visibleElements(): any[] {
        const query = this.elementQuery.trim().toLowerCase();
        return this.pageElements.filter((element) => {
            if (this.elementType !== 'all' && element.type !== this.elementType) return false;
            if (!query) return true;
            return String(element.text || '').toLowerCase().indexOf(query) >= 0
                || String(element.id || '').toLowerCase().indexOf(query) >= 0;
        });
    }

    public get selectedTypeLabel(): string {
        if (!this.selectedDraft) return '선택 없음';
        if (this.selectedDraft.custom) return '새 텍스트';
        return this.selectedDraft.type === 'image' ? '이미지' : '텍스트';
    }

    public async loadInfo() {
        const { code, data } = await wiz.call('info', {
            file: this.selectedFile,
        });
        if (code === 200) {
            this.filename = data.filename;
            this.selectedFile = data.filename;
            this.pdfFiles = data.files || [];
            this.pageCount = data.pageCount || 1;
            this.outputs = data.outputs || [];
            this.syncFileUrl();
        } else {
            this.message = data?.message || 'PDF 정보를 불러오지 못했습니다.';
        }
    }

    public async loadPage(page: number = this.currentPage) {
        this.loading = true;
        this.message = '';
        this.currentPage = this.clampPage(page);
        this.pageInput = this.currentPage;
        this.clearSelection();

        const { code, data } = await wiz.call('page', {
            file: this.selectedFile,
            page: this.currentPage,
            zoom: this.zoom,
        });

        if (code === 200) {
            this.pageCount = data.pageCount || this.pageCount;
            this.pageWidth = data.pageWidth || 1;
            this.pageHeight = data.pageHeight || 1;
            this.imageWidth = data.imageWidth || 1;
            this.imageHeight = data.imageHeight || 1;
            this.renderScale = data.renderScale || (this.imageWidth / this.pageWidth);
            this.pageImage = `data:image/png;base64,${data.image}`;
            this.pageElements = this.mergeCustomElements(data.elements || []);
        } else {
            this.message = data?.message || '페이지를 불러오지 못했습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public async previousPage() {
        await this.loadPage(this.currentPage - 1);
    }

    public async nextPage() {
        await this.loadPage(this.currentPage + 1);
    }

    public async jumpPage() {
        await this.loadPage(this.pageInput);
    }

    public async refreshZoom() {
        await this.loadPage(this.currentPage);
    }

    public async changeFile() {
        this.edits = {};
        this.savedFile = '';
        this.pageElements = [];
        this.pageImage = '';
        this.currentPage = 1;
        this.pageInput = 1;
        this.clearSelection();
        await this.loadInfo();
        await this.loadPage(1);
    }

    public selectElement(element: any) {
        this.selectedElement = element;
        this.selectedDraft = this.cloneDraft(this.displayDraft(element));
    }

    public clearSelection() {
        this.selectedElement = null;
        this.selectedDraft = null;
        this.pointerState = null;
    }

    public addTextBox() {
        const width = Math.min(180, this.pageWidth - 40);
        const element = {
            id: `p${this.currentPage}-c${Date.now()}`,
            type: 'text',
            page: this.currentPage,
            text: '새 텍스트',
            x: Math.max(20, (this.pageWidth - width) / 2),
            y: Math.max(20, this.pageHeight * 0.18),
            w: width,
            h: 32,
            origX: Math.max(20, (this.pageWidth - width) / 2),
            origY: Math.max(20, this.pageHeight * 0.18),
            origW: width,
            origH: 32,
            fontSize: 12,
            font: 'NanumGothic',
            color: '#111827',
            fill: '#ffffff',
            coverOriginal: false,
            deleted: false,
            custom: true,
        };
        this.pageElements = [element, ...this.pageElements];
        this.selectElement(element);
        this.applySelectedForm();
    }

    public applySelectedForm() {
        if (!this.selectedDraft) return;
        const draft = this.normalizeDraft(this.selectedDraft);
        this.selectedDraft = draft;
        this.edits[draft.key] = this.cloneDraft(draft);
        this.savedFile = '';
    }

    public deleteSelected() {
        if (!this.selectedDraft) return;
        this.selectedDraft.deleted = true;
        this.selectedDraft.coverOriginal = true;
        this.applySelectedForm();
    }

    public restoreSelected() {
        if (!this.selectedDraft) return;
        const key = this.selectedDraft.key;
        const wasCustom = this.selectedDraft.custom;
        delete this.edits[key];
        this.savedFile = '';
        if (wasCustom) {
            this.pageElements = this.pageElements.filter((element) => this.editKey(element) !== key);
            this.clearSelection();
            return;
        }
        if (this.selectedElement) {
            this.selectedDraft = this.cloneDraft(this.baseDraft(this.selectedElement));
        }
    }

    public async savePdf() {
        const edits = this.editList;
        if (edits.length === 0) {
            this.message = '저장할 수정 내역이 없습니다.';
            await this.service.render();
            return;
        }

        this.saving = true;
        this.message = '';
        const { code, data } = await wiz.call('save', {
            file: this.selectedFile,
            edits: JSON.stringify(edits),
        });
        this.saving = false;

        if (code === 200) {
            this.savedFile = data.filename;
            this.outputs = data.outputs || [];
            this.message = data.message || '저장되었습니다.';
        } else {
            this.message = data?.message || 'PDF 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public downloadSaved(filename: string = this.savedFile) {
        if (!filename) return;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/wiz/api/page.pdfeditor/download';
        form.style.display = 'none';

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'filename';
        input.value = filename;
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
        window.setTimeout(() => form.remove(), 1000);
    }

    public beginMove(event: MouseEvent, element: any) {
        event.preventDefault();
        event.stopPropagation();
        this.selectElement(element);
        this.pointerState = {
            mode: 'move',
            started: false,
            startX: event.clientX,
            startY: event.clientY,
            draftX: this.selectedDraft.x,
            draftY: this.selectedDraft.y,
            draftW: this.selectedDraft.w,
            draftH: this.selectedDraft.h,
        };
    }

    public beginResize(event: MouseEvent, element: any) {
        event.preventDefault();
        event.stopPropagation();
        this.selectElement(element);
        this.pointerState = {
            mode: 'resize',
            started: false,
            startX: event.clientX,
            startY: event.clientY,
            draftX: this.selectedDraft.x,
            draftY: this.selectedDraft.y,
            draftW: this.selectedDraft.w,
            draftH: this.selectedDraft.h,
        };
    }

    @HostListener('document:mousemove', ['$event'])
    public onMouseMove(event: MouseEvent) {
        if (!this.pointerState || !this.selectedDraft) return;
        const dxPixels = event.clientX - this.pointerState.startX;
        const dyPixels = event.clientY - this.pointerState.startY;
        if (!this.pointerState.started && Math.abs(dxPixels) + Math.abs(dyPixels) < 3) return;
        this.pointerState.started = true;

        const dx = dxPixels / this.renderScale;
        const dy = dyPixels / this.renderScale;
        if (this.pointerState.mode === 'resize') {
            this.selectedDraft.w = Math.max(8, this.pointerState.draftW + dx);
            this.selectedDraft.h = Math.max(8, this.pointerState.draftH + dy);
        } else {
            this.selectedDraft.x = this.pointerState.draftX + dx;
            this.selectedDraft.y = this.pointerState.draftY + dy;
        }
        this.applySelectedForm();
    }

    @HostListener('document:mouseup')
    public onMouseUp() {
        this.pointerState = null;
    }

    public pageShellStyle(): any {
        return {
            width: `${this.imageWidth}px`,
            height: `${this.imageHeight}px`,
        };
    }

    public overlayStyle(element: any): any {
        const draft = this.displayDraft(element);
        const changed = this.isChanged(element);
        const style: any = {
            left: `${draft.x * this.renderScale}px`,
            top: `${draft.y * this.renderScale}px`,
            width: `${Math.max(4, draft.w * this.renderScale)}px`,
            height: `${Math.max(4, draft.h * this.renderScale)}px`,
        };
        if ((changed || draft.deleted) && draft.coverOriginal) {
            style.background = draft.fill || '#ffffff';
        }
        return style;
    }

    public overlayClass(element: any): string {
        const base = 'absolute cursor-move overflow-hidden rounded-[2px] border transition';
        if (this.isSelected(element)) return `${base} border-zinc-950 ring-2 ring-zinc-950/20`;
        if (this.isChanged(element)) return `${base} border-sky-500/80 ring-1 ring-sky-400/20`;
        if (element.type === 'image') return `${base} border-amber-400/40 hover:border-amber-500`;
        return `${base} border-transparent hover:border-zinc-950/50 hover:bg-zinc-950/5`;
    }

    public previewTextStyle(element: any): any {
        const draft = this.displayDraft(element);
        return {
            color: draft.color || '#111827',
            fontSize: `${Math.max(4, draft.fontSize * this.renderScale)}px`,
            lineHeight: '1.05',
        };
    }

    public isPreviewVisible(element: any): boolean {
        const draft = this.displayDraft(element);
        return element.type === 'text' && this.isChanged(element) && !draft.deleted;
    }

    public isSelected(element: any): boolean {
        return !!this.selectedDraft && this.editKey(element) === this.selectedDraft.key;
    }

    public isChanged(element: any): boolean {
        return !!this.edits[this.editKey(element)];
    }

    public elementListClass(element: any): string {
        const base = 'w-full rounded-md border px-2 py-2 text-left text-xs transition';
        if (this.isSelected(element)) return `${base} border-zinc-950 bg-zinc-950 text-white`;
        if (this.isChanged(element)) return `${base} border-sky-200 bg-sky-50 text-sky-800 hover:border-sky-300`;
        return `${base} border-zinc-200 bg-white text-zinc-600 hover:border-zinc-300 hover:text-zinc-950`;
    }

    public displayText(element: any): string {
        const draft = this.displayDraft(element);
        return draft.deleted ? '' : String(draft.text || '');
    }

    public listText(element: any): string {
        const text = this.displayText(element).replace(/\s+/g, ' ').trim();
        if (!text) return element.type === 'image' ? '이미지 영역' : '(빈 텍스트)';
        return text.length > 42 ? `${text.slice(0, 42)}...` : text;
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '0 KB';
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        return `${Math.round(bytes / 1024)} KB`;
    }

    public shortFileName(name: string): string {
        return String(name || '').replace('국립문화유산연구원-', '');
    }

    private clampPage(page: number): number {
        const value = Number(page) || 1;
        return Math.max(1, Math.min(this.pageCount || 1, Math.round(value)));
    }

    private syncFileUrl() {
        if (location.pathname.indexOf('/pdf-editor') !== 0 || !this.selectedFile) return;
        history.replaceState({}, '', `/pdf-editor?file=${encodeURIComponent(this.selectedFile)}`);
    }

    private mergeCustomElements(elements: any[]): any[] {
        const customElements = this.editList
            .filter((edit) => edit.custom && edit.page === this.currentPage)
            .map((edit) => this.editAsElement(edit));
        return [...customElements, ...elements];
    }

    private editAsElement(edit: any): any {
        const element = this.cloneDraft(edit);
        element.id = edit.id;
        return element;
    }

    private displayDraft(element: any): any {
        const key = this.editKey(element);
        if (this.selectedDraft && this.selectedDraft.key === key) return this.selectedDraft;
        if (this.edits[key]) return this.edits[key];
        return this.baseDraft(element);
    }

    private baseDraft(element: any): any {
        return {
            key: this.editKey(element),
            id: element.id,
            type: element.type,
            page: element.page || this.currentPage,
            text: element.text || '',
            x: Number(element.x) || 0,
            y: Number(element.y) || 0,
            w: Math.max(1, Number(element.w) || 1),
            h: Math.max(1, Number(element.h) || 1),
            origX: Number(element.origX ?? element.x) || 0,
            origY: Number(element.origY ?? element.y) || 0,
            origW: Math.max(1, Number(element.origW ?? element.w) || 1),
            origH: Math.max(1, Number(element.origH ?? element.h) || 1),
            xref: Number(element.xref) || 0,
            fontSize: Math.max(4, Number(element.fontSize) || 10),
            color: element.color || '#111827',
            fill: element.fill || '#ffffff',
            coverOriginal: element.coverOriginal !== false,
            deleted: !!element.deleted,
            custom: !!element.custom,
        };
    }

    private normalizeDraft(draft: any): any {
        const normalized = this.cloneDraft(draft);
        normalized.x = this.clampNumber(normalized.x, 0, this.pageWidth - 1);
        normalized.y = this.clampNumber(normalized.y, 0, this.pageHeight - 1);
        normalized.w = this.clampNumber(normalized.w, 1, this.pageWidth - normalized.x);
        normalized.h = this.clampNumber(normalized.h, 1, this.pageHeight - normalized.y);
        normalized.fontSize = this.clampNumber(normalized.fontSize, 4, 96);
        normalized.text = String(normalized.text || '');
        normalized.page = this.currentPage;
        normalized.coverOriginal = !!normalized.coverOriginal;
        normalized.deleted = !!normalized.deleted;
        return normalized;
    }

    private clampNumber(value: any, min: number, max: number): number {
        const numberValue = Number(value);
        if (!Number.isFinite(numberValue)) return min;
        return Math.max(min, Math.min(max, numberValue));
    }

    private editKey(element: any): string {
        return `${element.page || this.currentPage}:${element.id}`;
    }

    private cloneDraft(value: any): any {
        return JSON.parse(JSON.stringify(value));
    }
}

export default PagePdfeditorComponent;